import emptyImage from '@fukuri-admins/assets/images/circle-calendar.svg';
import { ButtonLink, PlusIcon, Stack } from '@fukuri-admins/ui/common';
import styles from './empty.module.scss';

/**
 * 企業契約期間一覧 Empty 状態
 *
 * 企業契約期間が 0 件のときに表示する。
 * イラスト・メッセージ・「新規作成」ボタンを表示する。
 */
export const ClientContractListEmptyPresentation: React.FC = () => (
  <Stack
    gap={24}
    alignItems='center'
    justifyContent='center'
    height='100%'
    className={styles.container}
  >
    <img src={emptyImage} alt='empty list image' />
    <p className={styles.message}>企業契約期間はまだありません</p>
    <ButtonLink to='/client-contracts/new' icon={<PlusIcon size='xs' />} iconPosition='left'>
      新規作成
    </ButtonLink>
  </Stack>
);
